import React, { FC } from 'react';

type TagColor = 'blue' | 'purple' | 'green'

interface PathCardProps {
  icon: string
  title: string
  tag: string
  tagColor: TagColor
  children: React.ReactNode
  isHighlighted?: boolean
  className?: string
}

const TAG_COLOR_VARIANTS: Record<
  TagColor,
  string
> = {
  blue: 'bg-blue-100 text-blue-700',
  purple: 'bg-violet-100 text-violet-800',
  green: 'bg-green-200 text-green-800',
};

const PathCard: FC<PathCardProps> = ({
  icon,
  title,
  tag,
  tagColor,
  children,
  isHighlighted = false,
  className = '',
}) => {
  const containerClass = isHighlighted
    ? 'border-2 border-blue-600 bg-blue-50'
    : 'border border-slate-200 bg-gray-50';

  return (
    <article
      className={`
        rounded-lg-plus p-5 flex-1 min-w-[260px]
        ${containerClass}
        ${className}
      `}
    >
      <div className="flex items-center gap-2.5 mb-2.5">
        <span
          className="text-2xl"
          aria-hidden="true"
        >
          {icon}
        </span>
        <div>
          <p className="font-bold text-sm text-slate-800">
            {title}
          </p>
          <span
            className={`
              text-xs font-semibold tracking-wide
              px-2 py-0.5 rounded-full
              ${TAG_COLOR_VARIANTS[tagColor]}
            `}
          >
            {tag}
          </span>
        </div>
      </div>
      <div className="text-sm text-slate-600 leading-relaxed">
        {children}
      </div>
    </article>
  );
};

export default PathCard;
